import excelicon from "./excelicon.svg";

export default function ExcelIcon() {
  return (
    <img src={excelicon} />
  );
}